// extracted by mini-css-extract-plugin
export var container = "Testimonials-module--container--90a9a";
export var testimonial = "Testimonials-module--testimonial--4d91b";
export var testimonialClient = "Testimonials-module--testimonialClient--643e1";
export var testimonialText = "Testimonials-module--testimonialText--166e5";
export var testimonials = "Testimonials-module--testimonials--303fe";